export default __webpack_public_path__ + "static/media/location-image.375820ba.png";